import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { map } from 'rxjs/operators';
// import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

import { SERVER_API_URL } from 'app/app.constants';
import {AccountService} from '../../singelton/account.service';
import {isNullOrUndefined} from "@swimlane/ngx-datatable/release/utils";
import {LocalStorage} from "ngx-webstorage";
import {reject} from "q";

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {

 constructor(private http: HttpClient, private accountService: AccountService) {}  // , private $localStorage: LocalStorageService, private $sessionStorage: SessionStorageService) {}

  getToken() {
    return localStorage.getItem('authenticationToken') || sessionStorage.getItem('authenticationToken');
  }

  clearAuthenticationToken() {
    localStorage.removeItem('authenticationToken');
    sessionStorage.removeItem('authenticationToken');
  }

  getWebSocketUUID(){
    return localStorage.getItem('webSocketUUID') || sessionStorage.getItem('webSocketUUID');
 }


  login(credentials): Observable<any> {

  //  let path = this.getWebSocketUUID();

    // if(isNullOrUndefined(path))
    //   path=null;

    const data = {
      username: credentials.username,
      password: credentials.password,
      rememberMe: credentials.rememberMe,
      notificationPath: this.getWebSocketUUID()
    };

    function authenticateSuccess(resp) {
      const bearerToken = resp.headers.get('Authorization');
   //   alert( ' -----  >>>>>>>>  ' + JSON.stringify(resp) + resp.body.notify_path);
      const webSocketUUID = resp.body.notify_path;
 //     alert( ' -----  >>>>>>>>  ' + webSocketUUID);
      if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        const jwt = bearerToken.slice(7, bearerToken.length);
        this.storeAuthenticationToken(jwt, credentials.rememberMe, webSocketUUID);
        return jwt;
      }
    }

    return this.http.post(SERVER_API_URL + 'api/authenticate', data, { observe: 'response' }).pipe(map(authenticateSuccess.bind(this)));
  }

  // loginWithToken(jwt, rememberMe) {
  //   if (jwt) {
  //     this.storeAuthenticationToken(jwt, rememberMe);
  //     return Promise.resolve(jwt);
  //   } else {
  //     return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
  //   }
  // }

  storeAuthenticationToken(jwt, rememberMe, webSocketUUID) {
    // Always clear both storages first so rememberMe toggle cannot leave a stale twin token
    this.clearAuthenticationToken();

    if (rememberMe) {
      localStorage.setItem('authenticationToken', jwt);
      if (webSocketUUID) {
        localStorage.setItem('webSocketUUID', webSocketUUID);
      }
    } else {
      sessionStorage.setItem('authenticationToken', jwt);
      if (webSocketUUID && isNullOrUndefined(localStorage.getItem('webSocketUUID'))) {
        sessionStorage.setItem('webSocketUUID', webSocketUUID);
      }
    }
  }

  logout(): Observable<any> {

    // clear user account information
    return new Observable(observer => {
      this.accountService.logoutAccount(this.accountService.getWebSocketUUID()); //.then((res=> {
      localStorage.removeItem('authenticationToken');
      sessionStorage.removeItem('authenticationToken');
      localStorage.removeItem('webSocketUUID');
      sessionStorage.removeItem('webSocketUUID');
      observer.complete();
    //  }));
  });
  }
}
